import axios from "axios";
import { showErrorToast, showSuccessToast } from "../components/Toast";
import { getUserType, resolveUid } from "../utilities/cookieUtils";
import { getEncodedTimestamp } from "../utilities/dateUtils";
import PKSOFT_URLS from "../utilities/Pk_api_Urls";

import { addOrUpdateCartItem, removeCartItem } from "../utilities/cookieUtils";

export const addToCartAPI = async (
  mappingCode: string,
  qty: number = 1
): Promise<{ success: boolean; count?: number; messageCode?: number; message?: string }> => {
  try {
    const uid = resolveUid();
    const userType = getUserType();

    // ALWAYS update cookie for all users as per requirements
    
    // Random users: handle locally via cookies (already done above)
    if (userType === "random") {
      addOrUpdateCartItem(mappingCode, qty);
      return {
        success: true,
        messageCode: 100, // Mock success code for UI consistency
        message: "Added to cart"
      };
    }

    if (!uid) {
      showErrorToast("Unable to identify user. Please log in again.");
      return { success: false };
    }

    const response = await axios.post(`${PKSOFT_URLS.CUSTOMER.CART}/add`, {
      uid: uid,
      mappingCode: String(mappingCode),
      qty: qty, // Send quantity to backend
      d: getEncodedTimestamp(),
    });

    if (response.data.messageCode === 100 && response.data.status === 200) {
      const count = response.data?.data?.cartCount || 0;
      showSuccessToast(response.data.message);
      return {
        success: true,
        count,
        messageCode: response.data.messageCode,
        message: response.data.message,
      };
    }
    showErrorToast(response.data.message);
    return {
      success: false,
      messageCode: response.data?.messageCode,
      message: response.data?.message,
    };
  } catch (error: any) {
    console.error("Error adding to cart:", error);
    showErrorToast(
      error.response?.data?.message ||
      "Failed to add to cart. Please try again."
    );
    return { success: false };
  }
};

export const removeFromCartAPI = async (
  productId: string
): Promise<{ success: boolean; count?: number; messageCode?: number; message?: string }> => {
  try {
    const uid = resolveUid();
    const userType = getUserType();

    // ALWAYS remove from cookie for all users
    removeCartItem(productId);

    // Random users: handle locally via cookies (already done above)
    if (userType === "random") {
      return {
        success: true,
        messageCode: 100, // Mock success code for UI consistency
        message: "Removed from cart"
      };
    }

    if (!uid) {
      showErrorToast("Unable to identify user. Please log in again.");
      return { success: false };
    }

    const response = await axios.post(`${PKSOFT_URLS.CUSTOMER.CART}/remove`, {
      uid: uid,
      mappingCode: String(productId),
      d: getEncodedTimestamp(),
    });

    if (response.data.messageCode === 100 && response.data.status === 200) {
      const count = response.data?.data?.cartCount || 0;
      showSuccessToast(response.data.message);
      return {
        success: true,
        count,
        messageCode: response.data.messageCode,
        message: response.data.message,
      };
    }

    showErrorToast(response.data.message);
    return {
      success: false,
      messageCode: response.data?.messageCode,
      message: response.data?.message,
    };
  } catch (error: any) {
    console.error("Error removing from cart:", error);
    showErrorToast(
      error.response?.data?.message ||
      "Failed to remove from cart. Please try again."
    );
    return { success: false };
  }
};
